<template>
    <div v-bind:class="className">
        <div class="com-famous-comment-item-all dsp-flex">
            <div class="com-famous-ci-avatar">
                <img class="com-famous-ci-img-all" v-bind:src="itemData.userAvatar == '' ? avatarUrl : itemData.userAvatar" alt="">
            </div>
            <div class="com-famous-ci-content">
                <div class="com-famous-cic-title-all">
                    <span class="com-famous-cic-nickname">{{itemData.userName}}</span>
                    <span class="com-famous-cic-good" v-if="!itemData.isDelete" @click="clickMore">
                        <i class="iconfont icon-more"></i>
                    </span>
                </div>
                <div v-if="itemData.isDelete" class="com-famous-cic-content-delete">
                    <p>该评论已删除</p>
                </div>
                <div v-else class="com-famous-cic-content">
                    <p v-html="UTILS.getBreakLineByText(itemData.msg)"></p>
                </div>
                <div class="com-famous-cic-note">
                    <span class="com-famous-cic-date">{{itemData.timeStr}}</span>
                    <span v-if="!itemData.isDelete" class="com-famous-cic-good-2" @click="clickLike">
                        <span v-if="itemData.likeNum != 0" class="com-famous-cic-good-num">{{itemData.likeNum}}</span> <i class="iconfont" v-bind:class="{'icon-good2':itemData.isLike == 1, 'icon-good3':itemData.isLike == 0}"></i>
                    </span>
                    <span v-if="!itemData.isDelete" class="com-famous-cic-comment" @click="clickReply">
                        <i class="iconfont icon-comment-1"></i>
                    </span>
                </div>
            </div>
        </div>
        
        <!-- 回复列表 -->
        <div v-if="!itemData.isDelete && allSecondList.length > 0" class="com-famous-cic-second-list">
            <famous-comment-item-second
                v-for="data in allSecondList"
                v-bind:key="'second'+data.id"
                v-bind:secondItemData="data"
                v-bind:operateFunc="operateFunc">
            </famous-comment-item-second>
            <span class="com-famous-cic-note com-famous-cic-note-second" v-if="showReplyText != ''" @click="clickCheckReply">{{showReplyText}}</span>
        </div>
    </div>
</template>

<script>
import { UTILS } from '../../modules/utils'
import FamousCommentItemSecond from './FamousCommentItemSecond.vue'
export default {
    name: 'FamousCommentItemAll',
    components: { FamousCommentItemSecond },
    props: {
        type: {
            type: String,
            default() { return '' }
        },
        className: {
            type: String,
            default() { return '' }
        },
        itemData: {
            type: Object,
            default() { return {} }
        },
        secondList: {
            type: Object,
            default() { return {} }
        },
        operateFunc: {
            type: Function,
            default() { return null }
        }
    },
    data() {
        return {
            UTILS: UTILS,
            avatarUrl: require('../../assets/images/avatar.png'),
            showAllSecondList: false,
            allSecondList: [],
            showReplyText: ''
        }
    },
    mounted() {
        var me = this;
        setTimeout(() => {
            me.initData();
        }, 20);
        this.$bus.on('updateSecondList', this.initData)
    },
    destroyed() {
        this.$bus.off('updateSecondList', this.initData)
    },
    methods: {
        clickMore() {
            if(this.operateFunc && typeof(this.operateFunc) == 'function') {
                this.operateFunc('more', this.itemData)
            }
        },
        clickLike() {
            if(this.operateFunc && typeof(this.operateFunc) == 'function') {
                this.operateFunc('like', this.itemData)
            }
        },
        clickReply() {
            if(this.operateFunc && typeof(this.operateFunc) == 'function') {
                this.operateFunc('reply', this.itemData)
            }
        },
        clickCheckReply() {
            this.showAllSecondList = !this.showAllSecondList;
            this.initData();
        },
        initData() {
            var list = this.secondList && this.secondList[this.itemData.id] ? this.secondList[this.itemData.id] : [];
            // 处理列表数据
            if(this.showAllSecondList) {
                this.allSecondList = list
            }else {
                this.allSecondList = list.length >= 2 ? _.concat(list[0], list[1]) : list;
            }
            // 处理文本
            if(list.length > 2) {
                this.showReplyText = this.showAllSecondList ? '收起回复' : '展开其他' + (list.length - 2) + '条回复' ;
            }else {
                this.showReplyText = '';
            }
        }
    }
}
</script>